module.exports = __webpack_public_path__ + "img/feedback.3d5368dc.png";